







































































































































































































































































































































































































































































































































































import AccordionCardWidget from "@/components/base/AccordionCardWidget.vue";
import FeedbackComponent from '@/components/base/FeedbackComponent'
import MemberAccountsGrid from "@/components/dashboard/customer-service/components/MemberAccountsGrid.vue";
import SendNotification from "@/components/dashboard/customer-service/components/SendNotification.vue";
import MemberSubAccountsGrid from "@/components/dashboard/find-member-or-employer/tabs/MemberSubAccountsGrid.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {CrmFilterType} from "@/models/CrmFilterType";
import {EmployerCRMDetails, MemberCRMDetails} from "@/store/modules/customerService";
import {KeyValuePair, UserDetailsResponse} from "@payroll/optimus-common";
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";

export enum CRMFileType {
  FILE_ONE = 1,
  FILE_TWO = 2,
  FILE_THREE = 3,
  FILE_FOUR = 4,
  FILE_FIVE = 5
}

@Component({
  components: {
    MemberAccountsGrid,
    MemberSubAccountsGrid,
    AccordionCardWidget,
    SendNotification,
  }
})
export default class CreateNewCustomerServiceCRMContact extends FeedbackComponent {
  @Prop() memberCRMDetails?: MemberCRMDetails;
  @Prop() employerCRMDetails?: EmployerCRMDetails;
  @Prop(Array) memberAccounts!: any;
  @Prop() crmFilterType!: CrmFilterType;

  @Action('getSourceOfArrival', StoreNamespace.CUSTOMER_SERVICE) getSourceOfArrival: any;
  @Action('getSubjectOfArrivalByCrmFilterType', StoreNamespace.CUSTOMER_SERVICE) getSubjectOfArrivalByCrmFilterType: any;
  @Action('getCRMDepartments', StoreNamespace.CUSTOMER_SERVICE) getCRMDepartments: any;
  @Action('getAllStatusesTypesByCrmFilterType', StoreNamespace.CUSTOMER_SERVICE) getAllStatusesTypesByCrmFilterType: any;
  @Action('getUsersBySubjectOfArrivalId', StoreNamespace.CUSTOMER_SERVICE) getUsersBySubjectOfArrivalId: any;
  @Action('getServicePriorities', StoreNamespace.CUSTOMER_SERVICE) getServicePriorities: any;
  @Action('createNewCRMContact', StoreNamespace.CUSTOMER_SERVICE) createNewCRMContact: any;
  @Action('uploadCRMAttachedFiles', StoreNamespace.CUSTOMER_SERVICE) uploadCRMAttachedFiles: any;
  @Getter('userDetails', StoreNamespace.AUTHENTICATION) userDetails!: UserDetailsResponse
  @Action('getSubAccounts', StoreNamespace.CUSTOMER_SERVICE) getSubAccounts: any;
  @Action('getConfigCRMDetails', StoreNamespace.CUSTOMER_SERVICE) getConfigCRMDetails: any;


  @Watch('memberAccounts')
  onMemberAccountsChanged() {
    this.memberSubAccounts = null
  }


  private usersList: KeyValuePair[] = [];
  private userForRoutingList: KeyValuePair[] = []
  private selectedCRMFileType: CRMFileType = CRMFileType.FILE_ONE;
  private selectedMemberAccount = ''
  private sourceOfArrivalList: any[] | undefined = []
  private servicePrioritiesList: any[] | undefined = []
  private statusesTypesList: any[] | undefined = []
  private setOfFinalStatusIds: any[] = []
  private mapFromDepartmentToArrivalSubjectList: any = null
  private subjectOfArrivalList: any[] | undefined = []
  private departmentList: any[] | undefined = []
  private selectedDepartment: KeyValuePair = {} as KeyValuePair
  private selectedSourceOfArrival: KeyValuePair = {} as KeyValuePair
  private selectedStatusType: KeyValuePair = {} as KeyValuePair
  private selectedServicePriority: KeyValuePair = {} as KeyValuePair
  private selectedSubjectOfArrival: KeyValuePair = {} as KeyValuePair
  private fullKitDate: Date = new Date();
  private dateReceive: Date = new Date();
  private createdUser: string = ''
  private userForRouting: KeyValuePair | null = null
  private memberSubAccounts: any = null
  private companyLevelCrm: any = {}
  private showSubAccountSpinner: boolean = false;
  private sendNotification: boolean = false;

  private attachmentFileOne: File[] = [];
  private attachmentFileTwo: File[] = [];
  private attachmentFileThree: File[] = [];
  private attachmentFileFour: File[] = [];
  private attachmentFileFive: File[] = [];


  private contactId: string = "";
  private remarks: string = ''
  private internalRemarks: string = ''
  private notificationToSend: string = "";
  private emailToReplay: string = "";

  mounted() {
    this.usersList.push({description: this.userDetails.fullName, value: this.userDetails.idNumber})
    this.createdUser = this.usersList[0].description;

    this.getSubjectOfArrivalByCrmFilterType({
      requestorCallback: this,
      pathVariable: this.crmFilterType
    })

    this.getConfigCRMDetails({
      requestorCallback: this
    })

    this.getSourceOfArrival({
      requestorCallback: this,
      pathVariable: this.crmFilterType
    })

    this.getServicePriorities({
      requestorCallback: this
    })

    this.getAllStatusesTypesByCrmFilterType({
      requestorCallback: this,
      pathVariable: this.crmFilterType
    })

  }

  private onSelectedMemberAccount(accountDetails: any) {

    this.showSubAccountSpinner = true
    this.selectedMemberAccount = accountDetails.accountNum
    this.memberSubAccounts = null

    this.getSubAccounts({
      pathVariable: accountDetails.accountNumHashed,
      requestorCallback: this
    })

  }

  private onRemovedAttachmentClicked(fileType: CRMFileType) {
    switch (fileType) {
      case CRMFileType.FILE_ONE:
        this.attachmentFileOne = [];
        this.attachmentsMap.delete(fileType)
        break;
      case CRMFileType.FILE_TWO:
        this.attachmentFileTwo = [];
        this.attachmentsMap.delete(fileType)
        break;
      case CRMFileType.FILE_THREE:
        this.attachmentFileThree = [];
        this.attachmentsMap.delete(fileType)
        break;
      case CRMFileType.FILE_FOUR:
        this.attachmentFileFour = [];
        this.attachmentsMap.delete(fileType)
        break;
      case CRMFileType.FILE_FIVE:
        this.attachmentFileFive = [];
        this.attachmentsMap.delete(fileType)
        break;
    }
  }

  private attachmentsMap = new Map<number, any>();

  onInputFile(files: any[], fileType: CRMFileType) {
    if (files.length === 0) {
      return
    }

    this.attachmentsMap.set(fileType, files[0]);
  }

  private showCreateNewContactSpinner: boolean = false

  private createNewContact() {
    this.showCreateNewContactSpinner = true;

    const formNewContactDocuments: FormData = new FormData();
    this.attachmentsMap.forEach((value, key) => {
      formNewContactDocuments.append('files', value)
    });

    const newContactRequest = {
      memberId: this.memberCRMDetails?.personalId,
      employerId: this.employerCRMDetails?.employerId,
      accountNum: this.selectedMemberAccount,
      remarks: this.remarks,
      internalRemarks: this.internalRemarks,
      createdUser: this.createdUser,
      userForRouting: this.userForRouting?.value,
      userForRoutingName: this.userForRouting?.description,
      sourceOfArrival: Number.parseInt(this.selectedSourceOfArrival.value),
      subjectOfArrival: Number.parseInt(this.selectedSubjectOfArrival.value),
      statusType: Number.parseInt(this.selectedStatusType.value),
      servicePriorities: Number.parseInt(this.selectedServicePriority.value),
      addAttachment: this.attachmentsMap.size > 0,
      fullKitDate: this.fullKitDate,
      dateReceive: this.dateReceive
    }

    this.createNewCRMContact({
      requestBody: {
        ...newContactRequest,
      },
      requestorCallback: this
    })
  }

  private uploadAttachments() {
    if (this.attachmentsMap.size == 0) {
      this.afterSuccessfullyCreateCRMContact()
      return;
    }

    const formData: FormData = new FormData();
    formData.append('contactId', this.contactId)

    this.attachmentsMap.forEach((value, key) => {
      formData.append('files', value.file);
    });

    this.uploadCRMAttachedFiles({
      requestorCallback: this,
      requestBody: formData
    });
  }

  onSuccess(data?: any, requestName?: string, message?: string) {
    switch (requestName) {
      case 'getUsersBySubjectOfArrivalId':
        this.userForRoutingList = data.users
        this.emailToReplay = data.email
        break;

      case 'crmConfigurationManagement/getConfigCRMDetails':
        this.companyLevelCrm = data.companyLevelCrm
        break;

      case 'getSourceOfArrival':
        this.sourceOfArrivalList = data
        break;
      case 'getSubjectOfArrivalByCrmFilterType':
        this.mapFromDepartmentToArrivalSubjectList = data.mapFromDepartmentToSubjectList
        this.getCRMDepartments({
          requestorCallback: this,
          pathVariable: this.crmFilterType
        })

        break;
      case 'servicePriorities':
        this.servicePrioritiesList = data
        break;
      case 'getCRMDepartments':
        this.departmentList = data
        if (this.departmentList) {
          this.selectedDepartment = this.departmentList[0]
        }
        break;
      case 'statusesTypesByCrmFilterType':
        this.statusesTypesList = data.contactStatuses
        if (this.statusesTypesList) {
          this.selectedStatusType = this.statusesTypesList[0]
        }
        this.setOfFinalStatusIds = data.finalStatusIds

        break;
      case 'createNewCRMContact':
        this.contactId = data.contactId
        this.sendNotificationToCustomer()
        break;
      case 'uploadCRMAttachedFiles':
        this.afterSuccessfullyCreateCRMContact()
        break;
      case 'findMembersOrEmployersFor/subAccounts':
        this.showSubAccountSpinner = false;
        this.memberSubAccounts = data
        break;

    }
  }


  onError(messages: string[], code: number, requestName?: string): void {

    this.showCreateNewContactSpinner = false

    switch (requestName) {
      case 'uploadCRMAttachedFiles':
        this.showErrorPopupMessage(this.$t('customerService.popup.uploadAttachmentsErrorMessage').toString());
        break;

      case 'createNewCRMContact':
        this.showErrorPopupMessage(this.$t('customerService.popup.createNewContactErrorMessage').toString());
        break;
      default:
        this.handleOnError(messages, code, requestName);
    }
  }

  async sendNotificationToCustomer() {
    this.sendNotification = true;
    await new Promise(resolve => setTimeout(resolve, 1000));
    this.uploadAttachments()
  }

  onSelectedSubjectOfArrival(selectValue: any) {
    this.userForRoutingList = []
    this.getUsersBySubjectOfArrivalId({
      requestorCallback: this,
      pathVariable: selectValue.value
    })
  }

  onSelectedDepartment(selectValue: any) {
    const index: number = Number.parseInt(selectValue.value)
    this.subjectOfArrivalList = []
    if (this.mapFromDepartmentToArrivalSubjectList) {
      setTimeout(() => {
        this.subjectOfArrivalList = this.mapFromDepartmentToArrivalSubjectList[index]

      }, 100);
    }
  }

  afterSuccessfullyCreateCRMContact() {
    this.sendNotification = false
    this.remarks = "";
    this.internalRemarks = "";
    this.attachmentFileOne = [];
    this.attachmentFileTwo = [];
    this.attachmentFileThree = [];
    this.attachmentFileFour = [];
    this.attachmentFileFive = [];
    this.$emit('afterSuccessfullyCreated');
    this.showCreateNewContactSpinner = false;
  }

  private showErrorPopupMessage(message: string) {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: message,
      icon: 'warning',
      secondsToDisappear: 10
    })
  }

  get isFinalStatusSelected(): boolean {
    let idValue = Number.parseInt(this.selectedStatusType.value);

    return this.setOfFinalStatusIds.includes(idValue)
  }
}

